export enum CommunityMatchContactColumn {
  NAME,
  TITLE,
  OFFICE_PHONE,
  CELL_PHONE,
  EMAIL_ADDRESS,
  ADDED_BY,
  ADDRESS,
  LINKEDIN,
  REGION,
  TIME_ZONE,
  NOTES,
}
